export default __webpack_public_path__ + "static/media/KR.b8c4a87f.svg";